import { postRoute } from "../client"
import type { OpenCaseResult } from "../../shared/engagementTypes"

export const openCaseRoute = postRoute<OpenCaseResult>("/api/engagement/cases/open")
